:host {
  display: block;
}

.summary-card {
  margin: 0;
  box-sizing: border-box;
  padding: var(--spacing-6);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-lg);
  background: var(--color-gray-50);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: var(--spacing-4);
  min-height: var(--spacing-40);
}

.summary-items {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.summary-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  min-height: var(--spacing-6);
  font-size: var(--text-base);
  line-height: var(--leading-normal);
  color: var(--color-gray-900);
}

.summary-item dt {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.summary-item dt strong {
  font-weight: var(--font-weight-bold);
}

.summary-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-6);
  height: var(--spacing-6);
  flex: 0 0 var(--spacing-6);
}

.summary-icon hcds-icon {
  --hcds-icon-size: var(--spacing-6);
  display: block;
}

.summary-icon-svg {
  width: var(--spacing-6);
  height: var(--spacing-6);
  display: block;
}

.summary-item--valid .summary-icon {
  color: var(--color-green-600);
}

.summary-item--error .summary-icon {
  color: var(--color-red-500);
}

.summary-item--duplicate .summary-icon {
  color: var(--color-yellow-500);
}

/* Actions slot — right column of the grid */
.summary-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: var(--spacing-4);
}

::slotted(inmar-hc-button) {
  --hcds-icon-size: var(--spacing-5);
}

@media (max-width: 640px) {
  .summary-card {
    grid-template-columns: 1fr;
  }

  .summary-actions {
    align-items: flex-start;
  }
}
